import {Component, Input} from "@angular/core";

@Component({
    selector: "app-eform-footer",
    templateUrl: "./eform-footer.component.html",
    standalone: false
})
export class EformFooterComponent {
  @Input()
  isHomeMeasurement!: boolean;
}
